export default "__VITE_ASSET__BFEAedCl__"